import { render, staticRenderFns } from "./Ava.vue?vue&type=template&id=cff000ee&scoped=true"
import script from "./Ava.vue?vue&type=script&lang=js"
export * from "./Ava.vue?vue&type=script&lang=js"
import style0 from "./Ava.vue?vue&type=style&index=0&id=cff000ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff000ee",
  null
  
)

export default component.exports